const FEATURE_HELP_URLS = {};

export function getHelpUrlForFeature(featureName) {
  return '';
}
